import { Link, useLocation } from 'react-router-dom';
import {
  House,
  MapPin,
  ClipboardText,
  Clock,
  User,
} from '@phosphor-icons/react';
import { cn } from '../lib/utils';
import { useTranslationWithLanguage } from '../context/language-context';

export function BottomNavigation() {
  const location = useLocation();
  const pathname = location.pathname;
  const { t, language } = useTranslationWithLanguage();

  const navItems = [
    {
      name: t('navigation.home'),
      href: '/',
      icon: House,
    },
    {
      name: t('navigation.plan'),
      href: '/plan',
      icon: MapPin,
    },
    // {
    //   name: t('navigation.inspect'),
    //   href: '/inspections',
    //   icon: ClipboardText,
    // },
    {
      name: t('navigation.track'),
      href: '/track',
      icon: Clock,
    },
    {
      name: t('navigation.more'),
      href: '/menu',
      icon: User,
    },
  ];

  // Check if we're on the inspection questionnaire page to hide the bottom navigation
  const isInspectionQuestionnaire = pathname.includes('/questionnaire');

  if (isInspectionQuestionnaire) {
    return null; // Don't render bottom navigation on inspection questionnaire page
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] flex justify-center items-center">
      <div
        dir={language === 'ar' ? 'rtl' : 'ltr'}
        className="flex justify-around items-center h-16 bg-white border-t border-[var(--color-gold-200)]
        dark:bg-gray-900 dark:border-gray-800 w-full ipad-mini:max-w-xl surface-pro:max-w-2xl ipad:max-w-3xl ipad-pro:max-w-5xl ipad-pro-large:max-w-6xl"
      >
        {navItems.map((item) => {
          const isActive = pathname === item.href;
          return (
            <Link
              key={item.name}
              to={item.href}
              className="flex flex-col items-center justify-center w-full h-full"
            >
              <div
                className={cn(
                  'flex flex-col items-center justify-center',
                  isActive
                    ? 'text-[var(--color-gold-500)]'
                    : 'text-gray-500 dark:text-gray-400'
                )}
              >
                <item.icon
                  className="w-6 h-6"
                  weight={isActive ? 'fill' : 'regular'}
                />
                <span className="text-xs mt-1 tracking-wide font-light">
                  {item.name}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
